<template>
  <div class="calendar-widget" v-if="inited">
    <div class="tiny-widget flex items-center gap-0.5">
      <slot v-if="batchOrderSelected">
        <popup
          ref="batchEdit"
          className="font-bold no-underline mx-1 hidden"
          componentPath="pages/containers/replica"
          width="99%"
          height="100%"
          :pivot-y="0"
          :click-to-close="false"
          :options="batchOrderOptions"
        />
        <div class="batch-edit">
          <i class="el-icon-edit-outline px-1" />
          <el-dropdown v-if="!isEmptyData(importsToEdit)">
            <span class="el-dropdown-link text-xs">
              IM: {{ importsToEdit.length }}
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="batchEdit('ImportContainer', importsToEdit)"
              >
                Batch Edit
              </el-dropdown-item>
              <el-dropdown-item @click.native="copyBatchOrders(importsToEdit)">
                Copy Numbers
              </el-dropdown-item>
              <el-dropdown-item @click.native="clearBatchOrders(importsToEdit)">
                Clear Selectors
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown v-if="!isEmptyData(exportsToEdit)">
            <span class="el-dropdown-link text-xs">
              EX: {{ exportsToEdit.length }}
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="batchEdit('ExportContainer', exportsToEdit)"
              >
                Batch Edit
              </el-dropdown-item>
              <el-dropdown-item @click.native="copyBatchOrders(exportsToEdit)">
                Copy Numbers
              </el-dropdown-item>
              <el-dropdown-item @click.native="clearBatchOrders(exportsToEdit)">
                Clear Selectors
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="!isEmptyData(xtownsToEdit)">
            <span class="el-dropdown-link text-xs">
              XT: {{ xtownsToEdit.length }}
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="batchEdit('XtownContainer', xtownsToEdit)"
              >
                Batch Edit
              </el-dropdown-item>
              <el-dropdown-item @click.native="copyBatchOrders(xtownsToEdit)">
                Copy Numbers
              </el-dropdown-item>
              <el-dropdown-item @click.native="clearBatchOrders(xtownsToEdit)">
                Clear Selectors
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </slot>
      <div class="completed-statuses" v-if="completedCount != null">
        <div class="flex items-center leading-6 h-6">
          <svg
            width="20"
            height="20"
            viewBox="0 0 1.44 1.44"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.646 1.249a0.529 0.529 0 1 1 0.315 -0.953 0.045 0.045 0 0 1 -0.053 0.072 0.439 0.439 0 1 0 0.178 0.352 0.75 0.75 0 0 0 -0.005 -0.069 0.045 0.045 0 1 1 0.09 -0.014 0.75 0.75 0 0 1 0.005 0.083 0.529 0.529 0 0 1 -0.529 0.529"
              style="fill: #0074ff"
            />
            <path
              d="M0.704 0.889a0.045 0.045 0 0 1 -0.032 -0.013L0.458 0.661A0.045 0.045 0 0 1 0.522 0.598l0.182 0.181 0.542 -0.541a0.045 0.045 0 0 1 0.064 0.064l-0.574 0.574a0.045 0.045 0 0 1 -0.032 0.013"
              style="fill: #ffb300"
            />
          </svg>
          <div class="counters">
            <div
              class="text-red-500 cursor-pointer counter"
              :class="{ active: completedStatus == false }"
              @click="toggleCompletedStatus(false)"
            >
              {{ preferredItems.length - completedCount }}
            </div>
            <el-divider direction="vertical" />
            <div
              class="text-green-600 cursor-pointer counter"
              :class="{ active: completedStatus == true }"
              @click="toggleCompletedStatus(true)"
            >
              {{ completedCount }}
            </div>
          </div>
        </div>
      </div>
      <el-checkbox
        v-if="claimedCount > 0"
        v-model="filter.claimed"
        size="mini"
        border
        :disabled="withCompletedStatus"
      >
        Claimed({{ claimedCount }})
      </el-checkbox>
      <slot v-if="!isBroker">
        <div class="filter-widget" :class="{ disabled: withCompletedStatus }">
          <el-tooltip
            content="Move Type"
            placement="top-start"
            :open-delay="1000"
          >
            <el-radio-group
              v-model="filter.mission"
              size="mini"
              :disabled="withCompletedStatus"
            >
              <el-radio-button :label="null">&nbsp; All &nbsp;</el-radio-button>
              <el-radio-button
                v-for="name in missions"
                :key="name"
                :label="name"
              >
                {{ name.capitalize() }} {{ missionCount(name) }}
              </el-radio-button>
            </el-radio-group>
          </el-tooltip>
          <el-popover
            placement="top"
            width="480"
            popper-class="unwrapper"
            :disabled="withCompletedStatus"
          >
            <el-card class="box-card dense">
              <div slot="header" class="flex-space align-center">
                <div>More Filters</div>
                <div>
                  <a class="f90 red" v-if="filterChanged" @click="resetFilter">
                    Reset Filter
                  </a>
                  <el-divider
                    direction="vertical"
                    v-if="filterChanged"
                  ></el-divider>
                  <el-button size="mini" type="primary" @click="exportCsv"
                    >Export to CSV</el-button
                  >
                </div>
              </div>
              <el-form
                inline
                ref="form"
                class="e-form filter-form"
                label-position="top"
                size="mini"
              >
                <h4 class="flex-space">
                  <div>IMDL Filters</div>
                  <el-button
                    size="mini"
                    type="success"
                    class="micro"
                    @click.native="batchTrace()"
                    v-if="isTraceable"
                    >Batch Trace (ETA/LFD)</el-button
                  >
                </h4>
                <div>
                  <el-form-item label="Appt Status">
                    <el-tooltip
                      content="Status"
                      placement="top-start"
                      :open-delay="1000"
                    >
                      <el-checkbox-group v-model="filter.statuses" size="mini">
                        <el-checkbox-button label="confirmed">
                          Confirmed {{ confirmedCount }}
                        </el-checkbox-button>
                        <el-checkbox-button label="pre_alert">
                          Pre-Alert {{ preAlertCount }}
                        </el-checkbox-button>
                      </el-checkbox-group>
                    </el-tooltip>
                  </el-form-item>
                </div>
              </el-form>
              <el-form
                inline
                ref="form"
                class="e-form filter-form"
                label-position="top"
                size="mini"
              >
                <h4>Shared Filters</h4>
                <div class="flex-space">
                  <div>
                    <el-form-item label="Dispatched">
                      <el-checkbox-group v-model="filter.dispatched">
                        <el-checkbox-button label="yes">
                          Yes {{ dispatchedCount }}
                        </el-checkbox-button>
                        <el-checkbox-button label="no">
                          No {{ undispatchedCount }}
                        </el-checkbox-button>
                      </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="Mileage">
                      <el-select
                        v-model="filter.mileage"
                        style="width: 100px"
                        clearable
                      >
                        <el-option
                          v-for="name in mileRanges"
                          :key="name"
                          :label="name"
                          :value="name"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label=" ">
                      <el-checkbox
                        v-model="filter.pendingDocs"
                        class="narrow"
                        border
                      >
                        Pending Docs
                        <el-badge :value="pendingDocCount" />
                      </el-checkbox>
                    </el-form-item>
                    <el-form-item label="Brokered">
                      <el-checkbox-group v-model="filter.brokered">
                        <el-checkbox-button label="yes">
                          Yes {{ brokeredCount }}
                        </el-checkbox-button>
                        <el-checkbox-button label="no">
                          No {{ nonBrokeredCount }}
                        </el-checkbox-button>
                      </el-checkbox-group>
                    </el-form-item>
                  </div>
                  <div></div>
                </div>
              </el-form>
            </el-card>
            <el-button-group slot="reference">
              <el-button
                size="mini"
                icon="el-icon-s-operation text-sm"
                class="micro h-6"
              />
              <el-button
                v-if="filterChanged"
                type="danger"
                size="mini"
                class="micro h-6"
                @click="resetFilter"
                >Reset</el-button
              >
            </el-button-group>
          </el-popover>
        </div>
      </slot>
      <slot v-if="!isBroker">
        <el-tooltip
          content="Print Delivery Orders"
          placement="top"
          :open-delay="500"
        >
          <el-button
            v-if="onCalDay"
            size="mini"
            icon="el-icon-printer"
            @click="printPods"
            :disabled="isEmptyData(activeRoutes)"
          />
        </el-tooltip>
      </slot>
      <div>
        <el-tooltip content="Reload Orders" placement="top" :open-delay="500">
          <el-button size="mini" icon="el-icon-refresh" @click="loadData" />
        </el-tooltip>
      </div>
      <div>
        <el-tooltip content="Reorder Orders" placement="top" :open-delay="500">
          <el-button
            size="mini"
            icon="el-icon-sort"
            :disabled="!withItems"
            @click="reorderOrders"
          >
            <i class="fas fa-cubes" />
          </el-button>
        </el-tooltip>
      </div>
      <div v-if="!isBroker">
        <el-tooltip
          content="Schedule Driver Routes"
          placement="top"
          :open-delay="500"
        >
          <el-button
            v-if="onCalDay"
            size="mini"
            icon="el-icon-sort"
            @click="scheduleRoutes"
          >
            <i class="fas fa-route" />
          </el-button>
        </el-tooltip>
      </div>
      <slot v-if="!isBroker">
        <el-popover
          v-if="$store.layouts?.calendar?.color_styles"
          placement="bottom"
          title=""
          trigger="click"
        >
          <center>Default Color Styles</center>
          <table class="gray el-table nohover f90">
            <tr class="hp">
              <td class="em20">High Priority</td>
            </tr>
            <tr class="hold">
              <td class="em20">Appt. Hold</td>
            </tr>
            <tr v-for="style in orderDefaultColorStyles" :key="style.name">
              <td
                class="em20"
                :style="{ backgroundColor: style.bg, color: style.text }"
              >
                {{ style.name }}
              </td>
            </tr>
          </table>
          <el-button slot="reference" size="mini" icon="el-icon-question">
            Help
          </el-button>
        </el-popover>
      </slot>
      <el-input
        clearable
        placeholder="Quick Table Filter"
        v-model.lazy="keyword"
        size="mini"
        style="width: 200px"
        :disabled="withCompletedStatus"
      >
        <i slot="prefix" class="el-input__icon el-icon-s-grid" />
      </el-input>
      <a
        v-if="mark == 'not_sched'"
        class="el-icon-question text-lg red mx-0.5"
        @click="EGuide.open('not-sched')"
      />
    </div>
    <div class="h-full" :class="{ vertical: !horizontalDisplay }">
      <el-tabs class="tb-tabs" v-model="activeTab" v-if="horizontalDisplay">
        <el-tab-pane name="import">
          <span slot="label">
            <i class="el-icon-date"></i> Import
            <el-badge type="primary" :value="imports.length" />
          </span>
          <ContainerCalendarImdl
            type="Import"
            :mark="mark"
            :items="imports"
            :hubId="hubId"
          />
        </el-tab-pane>
        <el-tab-pane name="export">
          <span slot="label">
            <i class="el-icon-date"></i> Export
            <el-badge type="warning" :value="exports.length" />
          </span>
          <ContainerCalendarImdl
            type="Export"
            :mark="mark"
            :items="exports"
            :hubId="hubId"
          />
        </el-tab-pane>
        <el-tab-pane name="ltl">
          <span slot="label">
            <i class="el-icon-date"></i> TL
            <el-badge :value="fltls.length" />
          </span>
          <ContainerCalendarFltl :mark="mark" :items="fltls" :hubId="hubId" />
        </el-tab-pane>
        <el-tab-pane name="xtown" v-if="!isBroker">
          <span slot="label">
            <i class="el-icon-date"></i> XTown
            <el-badge type="primary" :value="xtowns.length" />
          </span>
          <ContainerCalendarImdl
            type="Import"
            :mark="mark"
            :items="xtowns"
            :hubId="hubId"
          />
        </el-tab-pane>
      </el-tabs>
      <slot v-else>
        <div class="header show-hide">
          <span>
            <i class="el-icon-date"></i> Import
            <el-badge type="primary" :value="imports.length" />
          </span>
        </div>
        <div>
          <ContainerCalendarImdl
            type="Import"
            :mark="mark"
            :items="imports"
            :virtual="verticalVirtual"
            :hubId="hubId"
          />
        </div>
        <div class="header show-hide">
          <span>
            <i class="el-icon-date"></i> Export
            <el-badge type="primary" :value="exports.length" />
          </span>
        </div>
        <div>
          <ContainerCalendarImdl
            type="Export"
            :mark="mark"
            :items="exports"
            :virtual="verticalVirtual"
            :hubId="hubId"
          />
        </div>
        <div class="header show-hide">
          <span>
            <i class="el-icon-date"></i> TL
            <el-badge :value="fltls.length" />
          </span>
        </div>
        <div>
          <ContainerCalendarFltl
            :mark="mark"
            :items="fltls"
            :virtual="verticalVirtual"
            :hubId="hubId"
          />
        </div>
        <slot v-if="!isBroker">
          <div class="header show-hide">
            <span>
              <i class="el-icon-date"></i> XTown
              <el-badge type="primary" :value="xtowns.length" />
            </span>
          </div>
          <div>
            <ContainerCalendarImdl
              type="Import"
              :mark="mark"
              :items="xtowns"
              :virtual="verticalVirtual"
              :hubId="hubId"
            />
          </div>
        </slot>
      </slot>
    </div>
  </div>
</template>
<script>
import api from "@/default/utils/api";
import ContainerCalendarImdl from "@/default/pages/containers/calendar/imdl.vue";
import ContainerCalendarFltl from "@/default/pages/containers/calendar/fltl.vue";
import {
  applyOrder,
  emptyOrderIds,
  hasOrderIds,
  loadOrderIds,
  restoreGroupOrder,
  restoreMissionOrder,
} from "@/default/pages/containers/calendar/reorder.vue";

export default {
  name: "ContainerCalendarWidget",
  mixins: [api],
  components: {
    ContainerCalendarImdl,
    ContainerCalendarFltl,
  },
  props: {
    mark: {
      type: String,
      required: true,
    },
    hubId: {
      type: Number,
      default: null,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    receivedData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLegacy: null,
      inited: this.isActive,
      activeTab: "import",
      appts: [],
      rawItems: [],
      keyword: "",
      mileRanges: ["< 100 mi", "100 - 200 mi", "200 - 300 mi", ">= 300 mi"],
      missions: [
        "load",
        "unload",
        "drop",
        "pickup",
        "prepull",
        "redelivery",
        "other",
      ],
      completedStatus: null,
      filter: {
        statuses: ["confirmed", "pre_alert"],
        mission: null,
        brokered: ["yes", "no"],
        dispatched: ["yes", "no"],
        mileage: "",
        pendingDocs: false,
        claimed: false,
      },
      fuseOptions: {
        shouldSort: true,
        threshold: 0.25,
        location: 0,
        distance: 50,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "id",
          "container_no",
          "reference_no",
          "chassis_no",
          "bl_no",
          "ctype",
          "terminals",
          "ssline.name",
          "customer.name",
          "warehouses.name",
          "warehouses.city",
          "truckers.name",
          "instructions",
          "tasks",
        ],
      },
      cachedFilter: {},
      batchOrderOptions: {},
      orderIds: emptyOrderIds(),
    };
  },
  mounted() {
    this.isLegacy = this.$store.settings.calendarLegacy;
    window.addEventListener("container-colorify", this.colorify);
  },
  async created() {
    this.cachedFilter = Object.assign({}, this.filter);
    NApp.dispatchTurboLoad();
    await this.loadData();
  },
  beforeDestroy() {
    this.rawItems = [];
    window.removeEventListener("container-colorify", this.colorify);
  },
  watch: {
    isActive(nv, ov) {
      if (nv) {
        this.inited = true;
        this.$nextTick(() => {
          setTimeout(() => window.dispatchEvent(new Event("resize")), 100);
        });
      }
    },
    receivedData(nv, ov) {
      if (JSON.stringify(nv) != JSON.stringify(ov)) {
        switch (nv.mark) {
          case "delete":
            this.consumeDelete();
            break;
          default:
            this.consumeDefault();
            break;
        }
      }
    },
    preferredItems(nv, ov) {
      this.$emit("updateCount", { mark: this.mark, count: nv.length });
    },
  },
  computed: {
    orderDefaultColorStyles() {
      return this.$store.envs.order_default_color_styles || [];
    },
    verticalVirtual() {
      return !this.horizontalDisplay && this.items.length > 50;
    },
    orientation() {
      return this.getSettings("calendarOrderDisplay", "horizontal");
    },
    completedOrdersHidden() {
      return this.getSettings("calendarCompletedOrdersHidden", false);
    },
    horizontalDisplay() {
      return this.orientation == "horizontal";
    },
    collapseHeight() {
      let offset = 100;
      return `calc(100vh - ${offset}px)`;
    },
    preferredItems() {
      if (!DriverPreferred.enabled()) return this.rawItems;
      const driverIds = this.$store.envs.preferred_drivers || [];
      return this.rawItems
        .map((item) => {
          let { transports } = item;
          let routes = this.onCalDay
            ? transports.filter((r) => [null, this.mark].includes(r.appt_date))
            : transports;
          transports = routes.filter((r) =>
            [null, ...driverIds].includes(r.trucker_id),
          );
          return { ...item, transports };
        })
        .filter((item) => !this.isEmptyData(item.transports));
    },
    withCompletedStatus() {
      return this.completedStatus != null;
    },
    completedCount() {
      if (this.onCalDay) {
        let items = this.preferredItems;
        const dates = [this.mark];
        return (
          items.length -
          items.filter((item) => {
            let routes = item.transports.filter((o) => !o.completed);
            let pending =
              routes.filter((o) => dates.includes(o.appt_date)).length > 0;
            this.$set(item, "completed", !pending);
            return pending;
          }).length
        );
      }
      return null;
    },
    nonBrokeredCount() {
      return this.preferredItems.filter((o) => !o.brokered).length;
    },
    brokeredCount() {
      return this.preferredItems.filter((o) => o.brokered).length;
    },
    items() {
      let items = this.preferredItems;
      if (
        this.onCalDay &&
        this.completedOrdersHidden &&
        !this.withCompletedStatus
      ) {
        const dates = [this.mark];
        items = items.filter((o) => {
          let routes = o.transports.filter((o) => !o.completed);
          return routes.filter((o) => dates.includes(o.appt_date)).length > 0;
        });
      }
      return items;
    },
    isTraceable() {
      return (
        this.$store.envs.trace &&
        JSON.stringify(this.filter.statuses) == JSON.stringify(["pre-alert"]) &&
        !this.isEmptyData(this.imports)
      );
    },
    filterChanged() {
      return JSON.stringify(this.cachedFilter) != JSON.stringify(this.filter);
    },
    withItems() {
      return this.items.length > 0;
    },
    drayageItems() {
      return this.items.filter((o) => o.category == "drayage");
    },
    ltlItems() {
      return this.items.filter((o) => o.category == "ltl");
    },
    showFilter() {
      return this.getSettings("calendarFilterDisplay", "show") == "show";
    },
    onCalDay() {
      return /\d{4}-\d{2}-\d{2}/.test(this.mark);
    },
    confirmedCount() {
      return this.drayageItems.filter((o) => o.state == "confirmed").length;
    },
    preAlertCount() {
      return this.drayageItems.filter((o) => o.state == "pre_alert").length;
    },
    missionCount() {
      return function (name) {
        return this.preferredItems.filter((o) => {
          return o.mission == name;
        }).length;
      };
    },
    isDispatched() {
      return (o) => {
        const transports = o.transports.filter((t) =>
          this.onCalDay ? t.appt_date == this.mark : true,
        );
        return transports.every((t) => t.trucker_id || t.brokered);
      };
    },
    dispatchedCount() {
      return this.items.filter((o) => this.isDispatched(o)).length;
    },
    undispatchedCount() {
      return this.items.filter((o) => !this.isDispatched(o)).length;
    },
    allDocs() {
      return this._.flatten(
        this._.flatten(
          this._.flatten(this.items.map((o) => o.transports)).map(
            (o) => o.operations,
          ),
        ).map((o) => o.docs),
      );
    },
    pendingDocCount() {
      return parseInt(this.sumArray(this.allDocs.map((o) => o.pending)));
    },
    claimedCount() {
      return this.items.filter((o) => o.claimed).length;
    },
    completedStatusFiltered() {
      return this.items.filter((o) => {
        return this.completedStatus === o.completed;
      });
    },
    defaultFiltered() {
      let items = this.items;
      items = items.filter((o) =>
        this.filter.dispatched.includes(this.isDispatched(o) ? "yes" : "no"),
      );

      items = items.filter((o) =>
        this.filter.brokered.includes(o.brokered ? "yes" : "no"),
      );

      if (!this.withCompletedStatus && this.filter.mission) {
        items = items.filter((o) => this.filter.mission == o.mission);
      }

      if (this.filter.pendingDocs) {
        items = items.filter((o) => {
          let docs = this._.flatten(
            this._.flatten(o.transports.map((o) => o.operations)).map(
              (o) => o.docs,
            ),
          );
          return docs.map((o) => o.pending).some((o) => o > 0);
        });
      }

      if (this.filter.claimed) {
        items = items.filter((o) => o.daily_routes.length > 0);
      }
      switch (this.mileRanges.indexOf(this.filter.mileage)) {
        case 0:
          items = items.filter((o) => o.mileage < 100);
          break;
        case 1:
          items = items.filter((o) => o.mileage >= 100 && o.mileage < 200);
          break;
        case 2:
          items = items.filter((o) => o.mileage >= 200 && o.mileage < 300);
          break;
        case 3:
          items = items.filter((o) => o.mileage >= 300);
          break;
        default:
          break;
      }
      const term = this.keyword.trim();
      if (term.length >= 3) {
        items = this.$search(term, items, this.fuseOptions).map((o) => o.item);
      }
      return items;
    },
    drayageFiltered() {
      let items = this.withCompletedStatus
        ? this.completedStatusFiltered
        : this.defaultFiltered;
      items = items.filter((o) => o.category == "drayage");

      if (!this.withCompletedStatus) {
        items = items.filter((o) => this.filter.statuses.includes(o.state));
      }
      return this._.groupBy(items, "type");
    },
    fltlFiltered() {
      let items = this.withCompletedStatus
        ? this.completedStatusFiltered
        : this.defaultFiltered;
      items = items.filter((o) => ["tl", "ltl"].includes(o.category));
      return items;
    },
    imports() {
      return this.drayageFiltered["ImportContainer"] || [];
    },
    exports() {
      return this.drayageFiltered["ExportContainer"] || [];
    },
    xtowns() {
      return this.drayageFiltered["XtownContainer"] || [];
    },
    fltls() {
      return this.fltlFiltered;
    },
    activeRoutes() {
      const routes = [];
      [this.drayageFiltered, this.fltlFiltered].forEach((group) => {
        routes.push(
          ...Object.values(group)
            .flat()
            .map((o) => o.transports.filter((t) => t.appt_date == this.mark))
            .flat(),
        );
      });
      return routes;
    },

    importsToEdit() {
      return this.imports.filter((o) => o.editing);
    },
    exportsToEdit() {
      return this.exports.filter((o) => o.editing);
    },
    xtownsToEdit() {
      return this.xtowns.filter((o) => o.editing);
    },
    batchOrderSelected() {
      return (
        this.importsToEdit.length > 0 ||
        this.exportsToEdit.length > 0 ||
        this.xtownsToEdit.length > 0
      );
    },
  },
  methods: {
    async loadData() {
      this.rawItems = [];
      await this.loadAppts();
      await this.loadOrders();
      this.orderIds = await loadOrderIds(this.mark, this.rawItems);
      this.applyOrderIds();
      this.initTab();
    },
    async loadAppts() {
      try {
        this.appts = (
          await this.$http.get(`/api/v1/calendar/appt`, {
            params: { mark: this.mark },
          })
        ).data;
      } catch (ex) {}
    },
    async loadOrders() {
      try {
        (
          await Promise.allSettled(
            this._.chunk(this.appts, 100).map(async (appts) => {
              return (
                await this.$http.post(`/api/v1/calendar/orders`, {
                  legacy: this.isLegacy,
                  mark: this.mark,
                  ids: appts,
                })
              ).data;
            }),
          )
        ).forEach((result) => {
          if (result.status == "fulfilled") {
            this.rawItems.push(...this.processItems(result.value));
          }
        });
      } catch (ex) {
        console.log(ex);
        this.$message({ message: ex.response.data.errors, type: "error" });
      }
    },
    applyOrderIds(ids) {
      if (ids) this.orderIds = ids;
      if (!hasOrderIds(this.orderIds)) return;
      applyOrder(this.rawItems, this.orderIds);
    },
    resetAppliedOrder() {
      this.orderIds = emptyOrderIds();
      restoreMissionOrder(this.rawItems, this.missions);
    },
    reorderOrders() {
      Dialog.open({
        componentPath: "pages/containers/calendar/reorder",
        width: "1200px",
        minWidth: 1200,
        height: "auto",
        pivotY: 0.1,
        clickToClose: false,
        mark: this.mark,
        hubId: this.hubId,
        orders: this.items.slice(),
        colorStyles: !!this.$store.layouts?.calendar?.color_styles,
        onOrdered: (ids, group) => {
          this.orderIds = ids || emptyOrderIds();
          if (group) {
            restoreGroupOrder(this.rawItems, group, this.missions);
          }
          if (hasOrderIds(this.orderIds)) {
            applyOrder(this.rawItems, this.orderIds);
          } else if (!group) {
            this.resetAppliedOrder();
          }
          return this.items.slice();
        },
      });
    },
    scheduleRoutes() {
      Dialog.open({
        componentPath: "pages/drivers/routes",
        width: "95%",
        pivotY: 0,
        clickToClose: true,
        date: this.mark,
      });
    },
    initTab() {
      const ris = this.rawItems;
      const imports = ris.filter((i) => i.type === "ImportContainer");
      const exports = ris.filter((i) => i.type === "ExportContainer");
      const ltl = ris.filter((i) => ["tl", "ltl"].includes(i.category));
      const xtown = ris.filter((i) => i.type === "XtownContainer");
      const tabVolumes = {
        import: imports.length,
        export: exports.length,
        ltl: ltl.length,
        xtown: xtown.length,
      };
      const maxVolumeTab = Object.keys(tabVolumes).reduce(
        (maxTab, currentTab) => {
          return tabVolumes[currentTab] > tabVolumes[maxTab]
            ? currentTab
            : maxTab;
        },
      );
      if (tabVolumes[maxVolumeTab] > 0) this.activeTab = maxVolumeTab;
    },
    processItems(items) {
      return items.map((item) => this.processItem(item));
    },
    processItem(item) {
      const calendarLayout = this.$store.layouts.calendar;
      const route = item.transports.find(
        (t) => t.appt_date == (this.onCalDay ? this.mark : null),
      );

      if (route) {
        this.$set(item, "mission", route.mission);
        this.$set(item, "rank", this.missions.indexOf(route.mission));
      }

      const routes = this.onCalDay
        ? item.transports.filter((o) => o.appt_date == this.mark)
        : item.transports;

      if (item.category == "drayage") {
        let locations = this._.flatten(
          item.transports.map((o) => o.operations),
        ).map((o) => o.company);
        locations = this._.uniqBy(locations, "id");
        item.warehouses = locations.filter((o) => "Warehouse" == o.type);

        let routedLocations = this._.flatten(
          routes.map((o) => o.operations),
        ).map((o) => o.company);
        routedLocations = this._.uniqBy(routedLocations, "id");

        const terminalRouted = calendarLayout.terminal_route_related;
        const terminals = (terminalRouted ? routedLocations : locations).filter(
          (o) => "Terminal" == o.type,
        );
        item.terminals = terminals.map((o) => o.name).join(";");

        const depotRouted = calendarLayout.depot_route_related;
        const depots = (depotRouted ? routedLocations : locations).filter(
          (o) => "Depot" == o.type,
        );
        item.depots = depots.map((o) => o.name).join(";");

        let mission = item.mission;
        if (["load", "unload", "drop"].includes(mission)) mission = "delivery";
        if (["pickup", "other"].includes(mission)) mission = "empty_return";
        item.claimed = !!(item.daily_routes || []).find(
          (o) => o.category == mission,
        );
        item.street_turn = {
          id:
            (item.street_turn_from && item.street_turn_from.id) ||
            (item.street_turn_to && item.street_turn_to.id) ||
            null,
        };
      }

      item.truckers = routes.map((o) => [o.trucker, o.carrier]);
      item.truckers = item.truckers.flat().filter((o) => o.id);
      //sort Operations by trucker name if truckers is empty
      if (!item.truckers[0]) item.truckers.push({ name: "" });

      item.brokered = routes.some((o) => o.brokered);
      item.mileage = this._.sum(
        item.transports
          .filter((o) => o.appt_date == this.mark)
          .map((o) => o.mileage),
      );
      item.route_est = route?.appt_start;
      return item;
    },
    consumeDelete() {
      let index = this.findCurrentIndex();
      if (index >= 0) {
        // console.log(`Sync Calendar Delete: ${index}`);
        this.rawItems.splice(index, 1); // delete
      }
    },
    consumeDefault() {
      this.onCalDay ? this.consumCalDay() : this.consumeNonCalDay();
    },
    findCurrentIndex() {
      return this.rawItems.findIndex((o) => o.id == this.receivedData.id);
    },
    consumeNonCalDay() {
      const data = this.receivedData;
      const { not_sched, upcoming } = data.appt_scopes;
      let index = this.findCurrentIndex();
      let toUpdate =
        (not_sched && this.mark == "not_sched") ||
        (upcoming && this.mark == "upcoming_loads");
      if (toUpdate) {
        this.syncContainer(index, Object.assign({}, data));
      } else {
        this.syncContainer(index);
      }
    },
    consumCalDay() {
      const data = this.receivedData;
      const appts = data.appt_scopes.appts;
      let index = this.findCurrentIndex();
      if (appts[this.mark]) {
        this.syncContainer(index, Object.assign({}, data));
      } else {
        this.syncContainer(index);
      }
    },
    syncContainer(index, data) {
      if (data) {
        this.processItem(data);
        const record = JSON.parse(JSON.stringify(data));
        if (index >= 0) {
          // console.log(`Sync Calendar Update (${index}): ${record.id}`);
          record.rank = this.rawItems[index]["rank"];
          record.editing = this.rawItems[index]["editing"];
          this.rawItems.splice(index, 1, record); // update
        } else {
          // console.log(`Sync Calendar Insert: ${record.id}`);
          this.rawItems.push(record); // insert
        }
      } else {
        if (index >= 0) {
          // console.log(`Sync Calendar Delete (${index})`);
          this.rawItems.splice(index, 1); // delete
        }
      }
      this.applyOrderIds();
    },
    resetFilter() {
      this.filter = Object.assign({}, this.cachedFilter);
    },
    exportCsv() {
      this.getDownload("/api/v1/calendar/appt.csv", { mark: this.mark });
    },
    async batchTrace() {
      try {
        await this.$confirm(
          `Are you sure to trace ETA/LFD for the ${this.imports.length} imports and ${this.xtowns.length} xtowns filtered order(s)?`,
        );

        const ids = this.imports.concat(this.xtowns).map((o) => o.id);
        const response = await this.$http2.post("/api/v1/traces/batch", {
          ids,
        });
        this.$message({
          message: response.data.message,
          type: "success",
        });
      } catch (err) {
        if (err !== "cancel") {
          console.error(err);
        }
      }
    },
    printPods() {
      this.$confirm("Are you sure to print DOs for the filtered orders?").then(
        () => {
          let routeIds = this.activeRoutes.map((o) => o.id);
          this.postDownload("/api/v1/pods/routes.pdf", {
            ids: routeIds,
            mark: this.mark,
          });
        },
      );
    },
    colorify(event) {
      const { id, color } = event.detail;
      const item = this.rawItems.find((item) => item.id === id);
      if (item) this.$set(item, "color", color);
    },
    toggleCompletedStatus(status) {
      if (this.completedStatus == status) {
        this.completedStatus = null;
      } else {
        this.completedStatus = status;
      }
    },
    batchEdit(type, orders) {
      const ids = orders.map((o) => o.id);
      this.batchOrderOptions = { mode: "edit", master: { type }, ids };
      this.$refs.batchEdit.open();
    },
    copyBatchOrders(orders) {
      const numbers = orders.map((o) => o.container_no).join("\n");
      this.$copyText(numbers).then(
        (e) => {
          this.$message({
            message: "Container numbers are copied to clipboard",
            type: "success",
          });
        },
        (e) => {},
      );
    },
    clearBatchOrders(orders) {
      orders.forEach((o) => {
        this.$set(o, "editing", false);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.calendar-widget {
  @apply h-[calc(100vh_-_100px)] min-h-[400px] overflow-auto;

  .tiny-widget::v-deep {
    @apply fixed right-1 py-0.5 rounded-sm;
  }
  .batch-edit {
    @apply empty:hidden bg-white px-1 rounded flex items-center divide-x;
    & > div {
      @apply px-1;
    }
  }
  .completed-statuses {
    @apply h-7 border border-gray-400 bg-white rounded px-2;
    .el-divider {
      @apply mx-1 #{!important};
    }
    .counters {
      @apply flex items-center text-sm font-bold;
      .counter {
        @apply w-6 text-center rounded;
        &.active {
          @apply bg-sky-100 border border-sky-400 rounded-full;
        }
      }
    }
  }
}
.filter-widget::v-deep {
  @apply bg-white hover:bg-gray-200 px-0.5 h-7 border border-gray-400 rounded flex items-center gap-1;
  &.disabled {
    @apply cursor-not-allowed;
  }
}
.tiny-widget::v-deep,
.filter-form::v-deep {
  .el-radio-button--mini {
    .el-radio-button__inner {
      @apply p-1;
    }
  }
  .el-checkbox.is-bordered {
    @apply h-7 mr-0 #{!important};
  }
  .el-checkbox-button--mini {
    .el-checkbox-button__inner {
      @apply p-1 h-6 leading-3 text-xs font-semibold;
    }
  }
}
.vertical {
  @apply space-y-1;
  .header {
    @apply sticky top-0 border p-1.5 bg-slate-100 z-50;
  }
}
</style>
